<template>
  <div>
    <Typography h2 bold label="การตั้งค่าเมนู" />

    <div class="ml-5">
      <v-card
        class="mt-4"
        style="border-radius: 10px; padding: 18px; box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15)"
      >
        <Typography h4 bold label="ขั้นตอนเบิกค่าใช้จ่ายคืน" />
        <Typography
          h4
          medium
          color="color-error"
          label="*ต้องเป็นลิ้งก์ที่ขึ้นต้นด้วย  https://  เท่าน้ัน"
        />
        <v-layout class="w-100 mt-4">
          <Typography v-if="!editstep" h4 medium :label="showData.step" />
          <div v-else-if="editstep" class="form-inline form-control w-100">
            <input
              type="text"
              style="width: 60%"
              class="form-control"
              name="ชื่อสมาชิก"
              v-model="editData.step"
            />
          </div>
          <img
            v-if="!editstep"
            @click="editstep = true"
            src="/static/img/TooltipEdit.png"
            alt
            class="responsive-img pointer ml-3"
            style="height: 22px"
          />
        </v-layout>
        <v-layout v-if="editstep" justify-center>
          <v-btn color="primary" @click="saveStep">ตกลง</v-btn>
          <v-btn
            @click="
              editData.step = showData.step
              editstep = false
            "
            >ยกเลิก</v-btn
          >
        </v-layout>
      </v-card>

      <v-card
        class="mt-3"
        style="border-radius: 10px; padding: 18px; box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15)"
      >
        <Typography h4 bold label="ติดต่อเรา" />
        <v-layout class="w-100 mt-4">
          <Typography v-if="!editContact" h4 medium :label="showData.contact" />
          <div v-else-if="editContact" class="form-inline form-control w-100">
            <input
              type="text"
              style="width: 60%"
              class="form-control"
              name="ชื่อสมาชิก"
              v-model="editData.contact"
            />
          </div>

          <img
            v-if="!editContact"
            @click="editContact = true"
            src="/static/img/TooltipEdit.png"
            alt
            class="responsive-img pointer ml-3"
            style="height: 22px"
          />
        </v-layout>
        <v-layout v-if="editContact" justify-center>
          <v-btn color="primary" @click="saveContact">ตกลง</v-btn>
          <v-btn
            @click="
              editData.contact = showData.contact
              editContact = false
            "
            >ยกเลิก</v-btn
          >
        </v-layout>
      </v-card>
    </div>
  </div>
</template>

<script>
import Typography from '@/components/elements/Typography.vue'
import api from '@/api'

export default {
  components: { Typography },
  data() {
    return {
      loading: false,
      editstep: false,
      editContact: false,
      editData: {
        step: '',
        contact: '',
      },
      showData: {
        step: '',
        contact: '',
      },
    }
  },
  computed: {},
  mounted() {
    this.setup()
  },
  methods: {
    setup() {
      this.getTapLinkConfig()
    },
    async saveStep() {
      let res = await api.updateTapLinkConfig({ step: this.editData.step })
      if (res) {
        this.showData.step = res.step
        this.showData.contact = res.contact
        this.editData = res
        this.editstep = false
      }
    },
    async saveContact() {
      let res = await api.updateTapLinkConfig({ contact: this.editData.contact })
      if (res) {
        this.showData.step = res.step
        this.showData.contact = res.contact
        this.editData = res
        this.editContact = false
      }
    },
    async getTapLinkConfig() {
      let res = await api.getTapLinkConfig()
      if (res) {
        this.showData.step = res.step
        this.showData.contact = res.contact
        this.editData = res
      }
      // console.log(res);
    },
    clearEdit() {
      ;(this.editstep = false), (this.editContact = false)
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/techhuntTapSetting/main.vue